/*
 *
 * ModeBar reducer
 *
 */

import ActionTypes from './constants';
import { ContainerActions, ContainerState } from './types';

export enum ConfiguratorMode {
  selector = 'selector',
  paint = 'paint',
  delete = 'delete',
  handles = 'handles',
}

export enum HandlesMode {
  doors = 'doors',
  bigShelves = 'bigShelves',
  drawers = 'drawers',
}

export const initialState: ContainerState = {
  activeMode: ConfiguratorMode.selector,
  handlesMode: HandlesMode.doors,
  lastTabName: undefined,
  lastShelvesSelection: undefined,
};

function modeBarReducer(
  state: ContainerState = initialState,
  action: ContainerActions,
): ContainerState {
  switch (action.type) {
    case ActionTypes.SWITCH_MODE:
      return {
        ...state,
        activeMode: action.payload.mode,
        lastTabName: action.payload.lastTabName,
      };
    case ActionTypes.SWITCH_HANDLE_MODE:
      return { ...state, handlesMode: action.payload.handlesMode };
    default:
      return state;
  }
}

export default modeBarReducer;
